import { Text, HStack } from '@genial/components';
import React from 'react';

export const AccountColumnsHeader: React.FC = () => {
  return (
    <HStack alignItems="center" space="inline.nano" flex={1}>
      <HStack flex={1}>
        <Text variant="semibold" fontSize="xs" color="neutral.dark">
          Conta de custódia
        </Text>
      </HStack>
      <HStack flex={1} justifyContent="flex-end">
        <Text variant="semibold" fontSize="xs" color="neutral.medium">
          Conta Sinacor
        </Text>
      </HStack>
    </HStack>
  );
};
